import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const fetchIncidents = async (query) => {
    const result = await apiClient.get(`${ENDPOINTS.incidents}?${query}`);
    return result?.data;
};

export const useFetchIncidents = ({ query, isEnabled = true, ...options } = {}) => {
    const { data, isFetched, ...rest } = useQuery({
        queryKey: queryKeys.incidents(query),
        queryFn: () => fetchIncidents(query),
        enabled: isEnabled,
        refetchOnMount: false,
        ...options,
    });

    return { data, isFetched, ...rest };
};
